@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.customWatchlistButton {
  padding: 0;
  aspect-ratio: 1;
  @include border-radius-full;

  &.active {
    color: var(--text-success);
    border-color: var(--border-success);
    background-color: var(--surface-success);

    svg {
      fill: var(--icon-success);
    }
  }

  &:not(.active) {
    color: var(--text-default);
    border-color: var(--border-default);
    background-color: var(--surface-default);

    svg {
      fill: var(--icon-default);
    }
  }
}

.contentWrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 24px;
}

.tickerWrapper {
  display: block;
}

.ticker {
  display: flex;
  flex-direction: row;
}

.leftImageContainer {
  display: flex;
  align-items: center;
  margin-right: 8px;
}

.titleContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  @include typography-v2-body-md;
}

.tag {
  color: var(--text-soft);
  text-transform: uppercase;
  align-items: center;
  @include typography-v2-body-xs;
}

.watchlistWrapper {
  margin-top: 3px;
  align-self: flex-start;
}
